import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'LOGIN_RECOVERY_TITLE',
    defaultMessage: 'Passwort vergessen?',
  },
  description: {
    id: 'LOGIN_RECOVERY_DESCRIPTION',
    defaultMessage:
      'Kein Problem: Geben Sie hier die E-Mail-Adresse oder Handynummer ein, mit der Sie sich bei XING einloggen.',
  },
  inputLabel: {
    id: 'LOGIN_RECOVERY_INPUT_LABEL',
    defaultMessage: 'E-Mail / Handy',
  },
  buttonContinue: {
    id: 'LOGIN_RECOVERY_CONTINUE',
    defaultMessage: 'Weiter',
  },
  invalidCode: {
    id: 'LOGIN_RECOVERY_INVALID_CODE',
    defaultMessage:
      'Leider ist der Code zum zurücksetzen des Passwortes nicht mehr gültig.',
  },
  invalidLink: {
    id: 'LOGIN_RECOVERY_INVALID_LINK',
    defaultMessage:
      'Leider ist der Link zum zurücksetzen des Passwortes nicht mehr gültig.',
  },
  problemsLoginRecoveryIntroduction: {
    id: 'LOGIN_RECOVERY_OTHER_PROBLEMS',
    defaultMessage: 'Andere Probleme beim Einloggen',
  },
  problemsLoginRecoveryLabel: {
    id: 'LOGIN_RECOVERY_OTHER_PROBLEMS_LINK_TEXT',
    defaultMessage: 'Kontaktieren Sie uns',
  },
  forgotOrNoAccessCredentialsRecoveryLabel: {
    id: 'LOGIN_RECOVERY_FORGOT_OR_NO_ACCESS_CREDENTIALS',
    defaultMessage: 'Probleme mit Ihrer E-Mail-Adresse oder Handynummer?',
  },
});
